import script from "./EmployeeProfileCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeProfileCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeProfileCardComponent.vue?vue&type=style&index=0&id=654db862&lang=css"

const __exports__ = script;

export default __exports__